var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "p-3 flex flex-col gap-2 bg-pure-white border rounded",
          class: [
            _vm.activeProspectStage
              ? "border-light-purple"
              : "border-slate-400",
            _vm.dragId === _vm.item.id ? "opacity-0" : "opacity-100",
            _vm.item.is_admitted ? "cursor-pointer" : "cursor-grab"
          ],
          attrs: { "data-id": _vm.item.id },
          on: {
            click: _vm.openPanel,
            mousedown: function($event) {
              return _vm.$emit("drag-start", {
                e: $event,
                prospect_stage: _vm.item
              })
            },
            touchstart: function($event) {
              return _vm.$emit("drag-start", {
                e: $event,
                prospect_stage: _vm.item
              })
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex", attrs: { title: _vm.item.prospect.name } },
            [
              _c("BlTextSubtitle2", {
                staticClass: "truncate",
                attrs: { text: _vm.item.prospect.name }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.item.upcoming_activities_count
            ? _c(
                "div",
                { staticClass: "flex items-center gap-2" },
                [
                  _c("BlIcon", {
                    staticClass: "w-4 h-4",
                    attrs: { icon: "list-check", color: "slate-6" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "px-1.5 h-5.5 flex items-center bg-lime-100 rounded"
                    },
                    [
                      _c("BlTextBody2", {
                        staticClass: "text-lime-700",
                        attrs: {
                          text:
                            _vm.item.upcoming_activities_count +
                            " upcoming to-do(s)"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative flex items-center gap-2" },
            [
              _c("BlIcon", {
                staticClass: "w-4 h-4",
                attrs: { icon: "tag", color: "slate-6" }
              }),
              _vm._v(" "),
              !_vm.tags.length
                ? _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        staticClass: "italic",
                        attrs: { text: "No tags" }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "flex items-center gap-2 truncate" },
                    [
                      _vm._l(_vm.tags.slice(0, 3), function(tag) {
                        return _c(
                          "div",
                          {
                            key: tag.id,
                            staticClass:
                              "px-1.5 h-5.5 min-w-12 flex items-center justify-center rounded truncate",
                            class: { "bg-slate-300": !tag.background_color },
                            style: {
                              backgroundColor: tag.background_color || "unset"
                            },
                            attrs: { title: tag.name }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              style: { color: tag.color || "unset" },
                              attrs: { text: tag.name }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.tags.slice(3).length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-shrink-0 items-center justify-center cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.openMoreTags = !_vm.openMoreTags
                                }
                              }
                            },
                            [
                              _c("BlBubbleCount", {
                                staticClass:
                                  "h-7 hover:bg-slate-400 text-slate-700 bg-slate-300",
                                attrs: {
                                  type: "secondary",
                                  count: "+ " + _vm.tags.slice(3).length
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
              _vm._v(" "),
              _vm.openMoreTags
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute z-50 top-8 right-0 p-1 gap-1 flex flex-col min-w-40 bg-pure-white rounded border border-slate-400 truncate"
                    },
                    _vm._l(_vm.tags.slice(3), function(tag) {
                      return _c(
                        "div",
                        {
                          key: tag.id,
                          staticClass:
                            "px-4 py-2 flex text-left rounded truncate max-w-48",
                          attrs: { title: tag.name }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: tag.name }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "relative flex items-center gap-2" },
            [
              _c("BlIcon", {
                staticClass: "w-4 h-4",
                attrs: { icon: "user", color: "slate-6" }
              }),
              _vm._v(" "),
              !_vm.assignedUsers.length
                ? _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        staticClass: "italic",
                        attrs: { text: "No assigned users" }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "flex items-center gap-2 truncate" },
                    [
                      _vm._l(_vm.assignedUsers.slice(0, 3), function(user) {
                        return _c(
                          "div",
                          {
                            key: user.id,
                            staticClass:
                              "px-1.5 h-5.5 flex items-center bg-slate-300 rounded truncate",
                            attrs: { title: user.name }
                          },
                          [
                            _c("BlTextBody2", {
                              staticClass: "truncate",
                              attrs: { text: user.name }
                            })
                          ],
                          1
                        )
                      }),
                      _vm._v(" "),
                      _vm.assignedUsers.slice(3).length
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "flex items-center justify-center cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.openMoreUsers = !_vm.openMoreUsers
                                }
                              }
                            },
                            [
                              _c("BlBubbleCount", {
                                staticClass:
                                  "h-7 hover:bg-slate-400 text-slate-700 bg-slate-300",
                                attrs: {
                                  type: "secondary",
                                  count:
                                    "+ " + _vm.assignedUsers.slice(3).length
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    2
                  ),
              _vm._v(" "),
              _vm.openMoreUsers
                ? _c(
                    "div",
                    {
                      staticClass:
                        "absolute z-50 top-8 right-0 p-1 gap-1 flex flex-col min-w-40 bg-pure-white rounded border border-slate-400 truncate"
                    },
                    _vm._l(_vm.assignedUsers.slice(3), function(user) {
                      return _c(
                        "div",
                        {
                          key: user.id,
                          staticClass:
                            "px-4 py-2 flex text-left rounded truncate max-w-48",
                          attrs: { title: user.name }
                        },
                        [
                          _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: { text: user.name }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.item.id
        ? _c("ProspectPanel", {
            attrs: {
              location: "kanban",
              open: _vm.panelOpened,
              id: _vm.item.id
            },
            on: {
              "close-panel": function($event) {
                _vm.panelOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7daa0876", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7daa0876","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/pipeline/ProspectStage.vue
// module id = null
// module chunks = 